<template>
  <div class="add-place-container">
    <span class="add-place-header">
      <h3>{{ $t("addPlace.title") }}</h3>
    </span>
    <hr />

    <!-- ROW g- ?? -->
    <div class="row g-3 align-items-center search-form-group">
      <div class="col-auto">
        <label for="placeSearchText">{{ $t("addPlace.searchLabel") }}</label>
      </div>
      <div class="col-auto">
        <input
          type="text"
          name="searchText"
          class="form-control place-search-input"
          id="placeSearchText"
          placeholder=""
          v-model="searchText"
          @keyup.enter="searchPlaceFromText"
        />
      </div>
      <div class="col-auto">
        <button
          class="btn btn-block mybtn tx-tfm search-place-button"
          @click="searchPlaceFromText"
          :disabled="canSearch == false"
        >
          {{ $t("addPlace.searchButton") }}
        </button>
      </div>
    </div>
    <div class="add-place-details">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-xs-12">
            <div class="selected-place-data">
              <div
                class="spinner-border doc-upload-spinner"
                role="status"
                v-if="loadingPlace"
              ></div>
              <span class="selected-place-visible" v-if="selectedPlace.name">
                <!-- Information about the selected place -->
                <h3>
                  {{ selectedPlace.name }}
                </h3>
                <p>
                  {{ selectedPlace.formatted_address }}
                </p>
                <div class="add-place-check">
                  <input
                    v-model="placeOwningCheck"
                    class="form-check-input"
                    type="checkbox"
                    id="placeOwningCheck"
                  />
                  <label class="add-place-check-label" for="placeOwningCheck">
                    {{ $t("addPlace.confirmPlace") }}
                  </label>
                </div>
                <!-- success alert -->
                <div
                  class="alert alert-success"
                  role="alert"
                  v-if="placeAddedSuccess"
                >
                  {{ $t("addPlace.addedSuccess") }}
                  <a :href="'/owner'"> {{ $t("addPlace.addedSuccessLink") }}</a>
                </div>
                <!-- checkbox alert -->
                <div
                  class="alert alert-primary"
                  role="alert"
                  v-if="placeOwningCheck && !alreadyAdded && !placeAddedSuccess"
                >
                  {{ $t("addPlace.confirmPlaceAlert") }}
                </div>
                <!-- already exists alert -->
                <div
                  class="alert alert-danger"
                  role="alert"
                  v-if="alreadyAdded"
                >
                  {{ $t("addPlace.alreadyAddedAlert") }}
                  <a :href="`mailto:${OWNER_CONTACT_EMAIL}`">
                    {{ $t("addPlace.contactUs") }}</a
                  >
                </div>
                <button
                  :disabled="
                    isAdding ||
                      (!placeOwningCheck && !placeAddedSuccess) ||
                      placeAddedSuccess
                  "
                  @click="addPlace"
                  type="submit"
                  class="btn btn-block mybtn btn-primary tx-tfm add-place-button"
                >
                  {{ $t("addPlace.addButton") }}
                </button>
              </span>
            </div>
          </div>
          <div class="col-lg-8 col-xs-12">
            <div class="map" ref="mapDivRef"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import router from "@/router";
import MapsService from "@/services/MapsService";
import PlaceService from "@/services/PlaceService";
const mapsService = new MapsService();
const placeService = new PlaceService();
import {
  MAPS_API_KEY,
  DEFAULT_MAP_TYPE,
  DEFAULT_ZOOM,
  DISABLE_DEFAULT_UI,
  DEFAULT_COORDS,
  OWNER_CONTACT_EMAIL,
} from "@/const";
export default defineComponent({
  name: "AddPlace",
  setup() {
    console.log("setup");
    const map = ref(null);
    const mapDivRef = ref(null);
    const owner = ref({});
    const selectedPlace = ref({});
    const loadingPlace = ref(true);
    const currentLocation = ref(DEFAULT_COORDS);

    const searchText = ref("");
    const canSearch = ref(false);
    const alreadyAdded = ref(false);
    const placeOwningCheck = ref(false);
    const placeAddedSuccess = ref(false);

    let placeMarker = null;

    const LSOwner = localStorage.getItem("owner");
    if (LSOwner == null) {
      router.replace("login");
      return;
    }
    const parsedOwner = JSON.parse(LSOwner);
    owner.value = parsedOwner;

    /**
     * trigered when a place is selected from the search input
     */
    const searchPlaceFromText = async () => {
      canSearch.value = false;
      alreadyAdded.value = false;
      placeOwningCheck.value = false;
      console.log("search place with", searchText.value);
      const result = await mapsService.getPlaceFromSearchText(
        owner.value.uid,
        searchText.value,
        currentLocation.value
      );
      console.log("result", result);
      if (result.place_id) {
        selectedPlace.value = result;
        selectedPlace.value.google_id = result.place_id;
        placeSelected(result);
      }
      canSearch.value = true;
    };

    onMounted(async () => {
      const googleMapScript = document.createElement("SCRIPT");
      googleMapScript.setAttribute(
        "src",
        `https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&callback=getCoordsAndInit`
      );

      googleMapScript.setAttribute("defer", "");
      googleMapScript.setAttribute("async", "");
      document.head.appendChild(googleMapScript);
    });
    /**
     * Called on init
     * get current position
     * and init map
     */
    window.getCoordsAndInit = async () => {
      if (navigator.geolocation) {
        console.log("hello 1");
        navigator.geolocation.getCurrentPosition((position) => {
          console.log("hello 2", position.coords);
          initMap({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        });
      } else {
        return DEFAULT_COORDS;
      }
    };

    /**
     * triggered when a place is selected
     * either by search or on map
     */
    const placeSelected = async (place) => {
      // remove marker if exists
      if (placeMarker != null) placeMarker.setMap(null);

      // add marker
      placeMarker = new window.google.maps.Marker({
        map: map.value,
        position: place.geometry.location,
        title: place.name,
        optimized: true,
      });

      //center map
      console.log("COORDS", currentLocation.value.lat);
      console.log("COORDS", DEFAULT_COORDS.lat);
      map.value.setCenter(place.geometry.location);
      //   map.value.setZoom(16);
      console.log("centered");
    };

    /**
     * Init the google maps
     */
    const initMap = async (coords) => {
      currentLocation.value = coords;
      console.log("init map");
      map.value = new window.google.maps.Map(mapDivRef.value, {
        mapTypeId: DEFAULT_MAP_TYPE,
        zoom: DEFAULT_ZOOM,
        disableDefaultUI: DISABLE_DEFAULT_UI,
        center: coords,
      });

      loadingPlace.value = false;
      canSearch.value = true;

      // click on map listener
      map.value.addListener("click", async (event) => {
        alreadyAdded.value = false;
        placeOwningCheck.value = false;
        loadingPlace.value = true;
        event.stop(); // prevent display the original google maps window
        console.log("click on map", event);
        if (event.placeId !== undefined) {
          console.log("event", event.placeId);
          const placeDetails = await mapsService.getDetailsFromBusinessId(
            owner.value.uid,
            event.placeId,
            false
          );
          console.log("FROM VIEW", placeDetails);

          if (placeDetails.formatted_address) {
            placeSelected(placeDetails);
            placeDetails.place_id = event.placeId;
            placeDetails.google_id = event.placeId;
            selectedPlace.value = placeDetails;
            console.log("TEST", selectedPlace.value);
          } else {
            loadingPlace.value = false;
            canSearch.value = true;
          }
          loadingPlace.value = false;
          canSearch.value = true;
        }
      });
    };
    return {
      mapDivRef,
      owner,
      selectedPlace,
      loadingPlace,
      currentLocation,
      searchPlaceFromText,
      searchText,
      canSearch,
      alreadyAdded,
      placeOwningCheck,
      placeAddedSuccess,
    };
  },
  methods: {
    async addPlace() {
      console.log("add ", this.selectedPlace);
      this.selectedPlace.owner_id = this.owner.uid;
      this.selectedPlace.line_address = this.selectedPlace.formatted_address;
      console.log("before add", this.selectedPlace);
      const addedPlace = await placeService.addPlaceByOwner(
        this.selectedPlace,
        this.owner.uid
      );
      console.log("added place from view", addedPlace);
      if (addedPlace.err) {
        // handle errors
        if (addedPlace.err == "PLACE_ALREADY_EXISTS") {
          this.alreadyAdded = true;
        }
      } else {
        this.placeAddedSuccess = true;
        this.canSearch = false;
      }
    },
  },
  data() {
    return {
      // placeOwningCheck: false,
    };
  },
});
</script>

<style></style>
